export enum DixaMessengerPanelForms {
  LanguageCustomizationPageForm = 'DixaMessengerCsatLanguageCustomizationPageForm',
  GlobalSettingsForm = 'DixaMessengerCsatGlobalSettingsForm',
}
